module.exports = __webpack_public_path__ + "static/media/schlauebox-wordmark.40f6a5e5.svg";